'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$119(ps$78) {
  this.a6K = null;
  this.a6K = ps$78;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$119 as $c_Lmealorama_jsonCodecs$package$$anon$119 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$119.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$119;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$119() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$119 as $h_Lmealorama_jsonCodecs$package$$anon$119 };
$h_Lmealorama_jsonCodecs$package$$anon$119.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6K.a.length;
});
$p.g = (function(i) {
  return this.a6K.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$119 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$119, "mealorama.jsonCodecs$package$$anon$119", ({
  It: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$119 as $d_Lmealorama_jsonCodecs$package$$anon$119 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$119.js.map
